jQuery(function($){

    $('.programme-contact-form select').on('change', function(){
        let $this = $(this),
            value = $this.val();
        
        if(value !== "") {
            $this.css({color: "#000000"});
        }else {
            $this.css({color: "#959595"});
        }
    })

});